type PencilProps = {
  className: string;
  color?: string;
};

export default function Pencil(props: PencilProps) {
  const color = props.color ?? "#757575";
  const className = props.className ?? "";
  return (
    <div className={className}>
      <svg
        style={{ width: "inherit", height: "inherit" }}
        viewBox="0 0 700 700"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5297 699.73C12.9056 699.729 8.46948 697.9 5.18959 694.64C3.22159 692.681 1.74801 690.281 0.890761 687.64C0.0335125 684.999 -0.182721 682.192 0.259658 679.45C5.97966 643.96 11.8695 607.8 17.5695 572.84C23.2695 537.88 29.1495 501.76 34.8595 466.3C35.4523 462.663 37.1736 459.305 39.7797 456.7L483.319 13.9297C492.034 5.23764 503.841 0.356445 516.15 0.356445C528.458 0.356445 540.265 5.23764 548.98 13.9297L685.819 150.771C690.684 155.664 694.455 161.535 696.882 167.994C699.309 174.453 700.338 181.354 699.9 188.24C699.584 193.843 698.1 199.317 695.543 204.312C692.985 209.306 689.411 213.71 685.05 217.24C575.52 326.75 520.69 381.37 467.69 434.15L465.53 436.3C412.02 489.61 356.69 544.74 242.23 659.2C239.65 661.781 236.329 663.491 232.73 664.09L20.3895 699.49C19.4444 699.648 18.488 699.728 17.5297 699.73ZM68.5297 477.47C63.0897 511.16 57.5295 545.34 52.1195 578.47C47.7095 605.54 43.1796 633.33 38.7096 660.96L221.47 630.48C333.28 518.68 387.96 464.21 440.859 411.48L443.02 409.32C496.14 356.41 551.019 301.69 661.079 191.67C661.672 191.075 662.308 190.524 662.98 190.021C663.43 189.691 664.79 188.67 664.98 185.7C665.063 183.822 664.758 181.946 664.083 180.191C663.409 178.436 662.379 176.839 661.06 175.5L524.23 38.6602C523.175 37.5844 521.916 36.7299 520.527 36.1465C519.138 35.5631 517.646 35.2627 516.14 35.2627C514.633 35.2627 513.141 35.5631 511.752 36.1465C510.363 36.7299 509.104 37.5844 508.05 38.6602L68.5297 477.47Z"
          fill={color}
        />
        <path
          d="M427.471 90.3906L425.06 92.8018C417.558 100.304 417.558 112.467 425.06 119.969L577.774 272.682C585.276 280.184 597.439 280.184 604.941 272.682L607.352 270.271C614.854 262.769 614.854 250.606 607.352 243.104L454.638 90.3906C447.136 82.8886 434.973 82.8886 427.471 90.3906Z"
          fill={color}
        />
        <path
          d="M144.43 679.12L22.3501 557.05L17.5303 682.23L144.43 679.12Z"
          fill={color}
        />
        <path
          d="M68.9859 446.613L66.5747 449.024C59.0727 456.526 59.0727 468.689 66.5747 476.191L219.289 628.905C226.791 636.407 238.954 636.407 246.456 628.905L248.867 626.494C256.369 618.992 256.369 606.829 248.867 599.327L96.1529 446.613C88.6509 439.111 76.4878 439.111 68.9859 446.613Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
